import React, { useEffect, useState } from "react";
import api from "../api";

const emptyForm = { id: null, holiday_date: "", name: "", type: "Public" };

const Holidays = () => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get("/holidays");
      setList(res.data || []);
    } catch (err) {
      console.error("Error loading holidays", err);
      alert("Error loading holidays");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        holiday_date: form.holiday_date,
        name: form.name,
        type: form.type || "Public",
      };
      if (form.id) {
        await api.put(`/holidays/${form.id}`, payload);
      } else {
        await api.post("/holidays", payload);
      }
      setForm(emptyForm);
      await load();
    } catch (err) {
      console.error("Save error", err);
      alert(err?.response?.data?.message || "Error saving holiday");
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (h) => {
    setForm({
      id: h.id,
      holiday_date: (h.holiday_date || "").slice(0, 10),
      name: h.name,
      type: h.type || "Public",
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this holiday?")) return;
    try {
      await api.delete(`/holidays/${id}`);
      await load();
    } catch (err) {
      console.error("Delete error", err);
      alert("Error deleting holiday");
    }
  };

  return (
    <>
      <div className="holiday-header">
        <>
        <h1>Holidays</h1>
        <p className="text-muted">
          Manage company-declared holidays. Dates are normalized to yyyy-mm-dd.
        </p>
        </>
      </div>
    
    <div className="card">
      <form onSubmit={handleSubmit} style={{ marginBottom: 14 }} className="filter-row">
        <div>
          <label className="filter-label">Date</label>
          <input
            type="date"
            className="filter-input"
            value={form.holiday_date}
            onChange={(e) => setForm((f) => ({ ...f, holiday_date: e.target.value }))}
            required
          />
        </div>
        <div>
          <label className="filter-label">Name</label>
          <input
            className="filter-input"
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            required
          />
        </div>
        <div>
          <label className="filter-label">Type</label>
          <input
            className="filter-input"
            value={form.type}
            onChange={(e) => setForm((f) => ({ ...f, type: e.target.value }))}
          />
        </div>
        <button className="btn btn-primary" type="submit" disabled={saving}>
          {saving ? "Saving..." : form.id ? "Update" : "Add"}
        </button>
        {form.id && (
          <button
            className="btn btn-secondary"
            type="button"
            onClick={() => setForm(emptyForm)}
          >
            Cancel
          </button>
        )}
      </form>

      {loading ? (
        <p>Loading...</p>
      ) : list.length === 0 ? (
        <p className="text-muted">No holidays added yet.</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Name</th>
                <th>Type</th>
                <th style={{ width: 120 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {list.map((h) => (
                <tr key={h.id}>
                  <td>{(h.holiday_date || "").slice(0, 10)}</td>
                  <td>{h.name}</td>
                  <td>{h.type}</td>
                  <td className="holiday-button">
                    <button className="btn btn-secondary" onClick={() => handleEdit(h)}>
                      Edit
                    </button>{" "}
                    <button
                      className="btn btn-danger"
                      onClick={() => handleDelete(h.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
    </>
  );
};

export default Holidays;
